<template>
  <div class="log-detail" v-loading.fullscreen.lock="loading">
    <el-page-header @back="goBack" content="日志详情"></el-page-header>
    <el-row class="mar" v-if="['onShelvesLog', 'publishStoresLog'].includes(getLogActiveName)">
      <el-col :span="5">{{getLogActiveName === 'publishStoresLog' ? '推送时间' : '铺货时间'}}：{{prodLogDetail.publishTime}}</el-col>
      <el-col :span="19">
        <span>{{getLogActiveName === 'publishStoresLog' ? '推送店铺' : '铺货店铺'}} ：{{prodLogDetail.shopName}}</span>
        <template v-if="prodLogDetail.hasRetry === 1">
          <div class="retry-tips el-link el-link--primary">
            <em class="el-icon-info"></em>
            <span class="tips-content">当前商品为存在参与“自动重试”逻辑而铺货成功的商品，需要查询其它数据，请返回上级页面更改筛选条件</span>
          </div>
        </template>
      </el-col>
    </el-row>
    <template v-if="getLogActiveName === 'onShelvesLogNew'">
      <el-row class="mar">
        <el-col :span="5">铺货时间：{{prodLogDetail.startTime}}</el-col>
        <el-col :span="19" class="flex">
          <span>铺货店铺： </span>
          <el-image v-if="prodLogDetail.platform" style="width: 18px; height: 18px" :src="getPlatformIcon(prodLogDetail.platform)"></el-image>
          <span v-if="prodLogDetail.platform" style="margin-left: 5px;">{{getPlatformName(prodLogDetail.platform)}}：</span>
          <span><span style="color:#51aafb;">{{prodLogDetail.shopCount}}</span>家</span>
        </el-col>
      </el-row>
      <el-row class="mar">
        <el-col :span="5" class="flex">
          图片：
          <el-popover
            v-if="prodLogDetail.image"
            placement="right"
            width="420"
            trigger="hover"
          >
            <el-image style="width: 400px;" :src="prodLogDetail.image"></el-image>
            <el-image slot="reference" style="width: 40px; height: 40px" :src="prodLogDetail.image"></el-image>
          </el-popover>
          
        </el-col>
        <el-col :span="5" class="flex">
          商品名称：
          <el-tooltip class="item" effect="dark" :content="prodLogDetail.title" placement="top">
            <div style="width:150px;" class="text-ellipsis">{{prodLogDetail.title}}</div>
          </el-tooltip>
        </el-col>
        <el-col :span="5" class="flex">
          款式编码：
          <el-tooltip class="item" effect="dark" :content="prodLogDetail.outerId" placement="top">
            <div style="width:150px;" class="text-ellipsis">{{prodLogDetail.outerId}}</div>
          </el-tooltip>
        </el-col>
      </el-row>
    </template>
    <el-tabs v-model="activeName">
      <el-tab-pane
        v-for="tab in tabList"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      >
        <template #label>
          {{ tab.label }}（{{ tab.list.length }}）
        </template>
        <div v-if="tab.buttons && tab.buttons.length && getLogActiveName !== 'publishStoresLog'" style="padding-bottom: 10px;">
          <el-button
            v-for="btn in tab.buttons"
            :key="btn.text"
            :type="btn.type"
            @click="btn.onClick"
            style="margin-right: 8px;"
          >
            {{ btn.text }}
          </el-button>
        </div>
        <el-popover
          placement="right"
          width="1060"
          v-if="tab.name === 'all' && $route.query.platformType === 'fxg'"
          trigger="hover">
          <div style="font-size: 14px;color: #878787;">
              <p>抖音后台素材状态查询：</p>
              <div>
                <p>前往抖音后台【商品素材】-【素材库】，复制素材名称，筛选审核中状态，查询素材审核详情，如图<span style="color:red;">(点击图片可查看图片大图)</span>：</p>
                
                <el-image :preview-src-list="srcList" :src="dyLogTips" style="width: 1030px;"></el-image>
              </div>
          </div>
          <el-button class="trigger-tips" slot="reference">如何查询抖音后台素材状态?</el-button>
        </el-popover>
        <Table
          v-if="getLogActiveName === 'onShelvesLog'"
          :list="tab.list"
          :selection="getLogActiveName === 'publishStoresLog' ? false : tab.selection "
          @selection-change="selectionChange"
          @stopPublishFn="stopPublishFn"
          @republish="rePublish"
        />
        <NewTable
          v-else
          :list="tab.list"
          :selection="tab.selection"
          @republish="rePublish"
          @selection-change="selectionChange"
          @stopPublishFn="stopPublishFn"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- 铺货结果展示 -->
    <BulkShelvesResults 
      v-if="isAReady"
      @search="fetch_Deatil"
      :publishSpeedResult="publishResult" 
      :percentage="publishPercenttage" 
      :pageId="pageId"/>
    <KttHandDialog ref="KttHandDialogRef" />
  </div>
</template>

<script>
import Table from './table.vue'
import KttHandDialog from '@components/prod/center/dialogs/KttHandDialog.vue';

import NewTable from './newTable.vue'
import { getPublishLogDetail,getPlatformProductPublishLogDetail, logPublishLogById,getPlatformProductPublishLogById, stopPublishTask } from '@servers/prod/log/index'
import { publishGoods } from '@/servers/prod/center';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { PLATFORM_ICONS_MAP,PLATFORM_NAME_MAP } from '@/dictionary/platforms.js';

export default {
  components: {
    Table,
    KttHandDialog,
    NewTable
  },
  props: ['id','operationLogId'],
  data() {
    return {
      activeName: 'all',
      list: [],
      sucessList: [],
      failList: [],
      executingList: [],
      queuingList: [],
      otherReasonList: [],
      prodLogDetail: '',
      loading: false,
      isAReady: false,
      selectList: [],
      dyLogTips: require("@/assets/images/dy_log_tips.png"),
      srcList:[require("@/assets/images/dy_log_tips.png")],
      isPublishing: false
    }
  },
  watch: {
    list: {
      handler(list) {
        const sucessList= [],
          failList = [],
          executingList = [],
          queuingList = [],
          otherReasonList = [];
        list.forEach(item => {
          const status = item.status;
          if(status == 1) {
            sucessList.push(item);
          } else if([0, 4].includes(status)) {
            failList.push(item);
          } else if([-1, 3].includes(status)) {
            executingList.push(item);
          } else if([-3, -2].includes(status)) {
            queuingList.push(item);
          } else if([5].includes(status)) {
            otherReasonList.push(item);
          }
        });
        this.sucessList = sucessList;
        this.failList = failList;
        this.executingList = executingList;
        this.queuingList = queuingList;
        this.otherReasonList = otherReasonList;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['speedResult', 'speedPercentage', 'routerPrefix', 'getLogActiveName', 'prodRePublishRowData']),
    ifUseTaskScheduling() {
      return this.$store.getters?.userInfo?.ifUseTaskScheduling
    },
    pageId() {
      return this.routerPrefix+"log"
    },
    publishResult() {
      return this.speedResult(this.routerPrefix+"log")
    },
    publishPercenttage() {
      return this.speedPercentage(this.routerPrefix+"log")
    },
    tabList() {
      return [
        {
          name: 'all',
          label: '全部',
          list: this.list,
          selection: true,
          buttons: [
            { text: '重新铺货', type: 'primary', onClick: this.batchRePublish },
            this.ifUseTaskScheduling
              ? { text: '终止铺货', type: 'primary', onClick: () => this.stopPublish() }
              : null
          ].filter(Boolean)
        },
        {
          name: 'queuing',
          label: '排队中',
          list: this.queuingList,
          selection: true,
          buttons: [
            { text: '终止铺货', type: 'primary', onClick: () => this.stopPublish(), if: 'ifUseTaskScheduling' }
          ]
        },
        {
          name: 'executing',
          label: '执行中',
          list: this.executingList,
          selection: false,
          buttons: []
        },
        {
          name: 'sucess',
          label: '成功',
          list: this.sucessList,
          selection: false,
          buttons: []
        },
        {
          name: 'fail',
          label: '失败',
          list: this.failList,
          selection: true,
          buttons: [
            { text: '重新铺货', type: 'primary', onClick: this.batchRePublish }
          ]
        },
        {
          name: 'otherReason',
          label: '其他原因',
          list: this.otherReasonList,
          selection: true,
          buttons: [
            { text: '重新铺货', type: 'primary', onClick: this.batchRePublish }
          ]
        }
      ]
    }
  },

  methods: {
    ...mapActions(['publishSpeed', 'clearRePublishRowData', 'clearDisplayRePublishRowData','isDistributor']),
    ...mapMutations(['setCurrentPage']),
    goBack() {
      console.log(this.$fromGyl, '---$fromGyl--')
      if(this.$fromGyl) {
         // 如果来自星云供应链，返回则直接回到初始状态
        this.$router.push({ path: '/hyc/bulkShelves' });
      }else{
        this.$router.back();
      }
    },
    async fetch_logDetail() {
      let reqApi = getPublishLogDetail
      if(this.getLogActiveName == 'onShelvesLogNew'){
        reqApi = getPlatformProductPublishLogDetail
      }
      let params = {
        id: this.id
      }
      if(this.operationLogId){
        params.publishLogId = this.operationLogId
      }
      const res = await reqApi(params);
      if(!res) return;
      if(!this.id){
        this.fetch_byIdDetail(res[0]?.operationLogId)
      }
      this.list = res.map(item => {
        const extendVal2 = JSON.parse(item.extendVal2 || '{}');
        return {
          ...item,
          shopIcon: item.platform ? PLATFORM_ICONS_MAP[item.platform] : null,
          storeName: extendVal2.storeName,
        }
      });
    },
    async fetch_byIdDetail(id) {
      if(!this.id && !id){
        return;
      }
      let params = {
        id:id || this.id
      }
      let reqApi = logPublishLogById
      if(this.getLogActiveName == 'onShelvesLogNew'){
        reqApi = getPlatformProductPublishLogById
      }
      const res = await reqApi(params);
      if(!res) return;
      this.prodLogDetail = res;
    },
    fetch_Deatil() {
      this.loading = true;
      Promise.all([this.fetch_logDetail(), this.fetch_byIdDetail()]).then(res=> {
        if(res) {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
      })
    },
    selectionChange(selectList) {
      this.selectList = selectList
    },
    getIds(list) {
      const shopIds = []
      const baseItemIds = list.map(item => {
        if(!shopIds.length && item.shopId) {
          shopIds.push(item.shopId)
        }
        return item.baseItemId
      })
      return {
        shopIds,
        baseItemIds,
      }
    },
    openKttEdit(itemList,baseItemIds, shopIds) {
      this.$refs.KttHandDialogRef.method_open({
        baseItemIds, 
        shopIds,
        okFn: (groupData, itemIds) => {
          this.postData(itemList, {batchTaskSchedulingConfig: groupData, itemIds });
        }
      });
    },
    
    // 通用的重新铺货处理方法
    handleRePublish(itemList) {
      if (!itemList?.length) {
        return;
      }
      
      const { baseItemIds, shopIds } = this.getIds(itemList);
      const platform = itemList[0]?.platform;
      
      if (platform === 'ktt') {
        this.openKttEdit(itemList, baseItemIds, shopIds);
      } else {
        this.postData(itemList);
      }
    },
    
    rePublish(row) {
      this.handleRePublish([row]);
    },
    
    async batchRePublish() {
      const failList = this.selectList.filter(item => [0, 4, 5].includes(item.status));
      
      if (!failList.length) {
        return this.$message.warning('请选择铺货失败/其他原因的商品重新铺货；');
      }
      
      this.handleRePublish(failList);
    },
    async postData(list, extraParams){
      if(this.isPublishing) return
      this.isPublishing = true;
      let { publishEntrance, platform, channel,taskCenterId,publishType:_publishType } = list[0];
      const { baseItemIds, shopIds } = this.getIds(list);
      let publishType = 'PUBLISH_ITEM'
      let params = {
        itemIds: baseItemIds,
        shopIds,
        taskEntrance: publishEntrance,
        taskType: publishType,
        channel,
        isDistribution:+this.isDistributor,
        ...extraParams
      }
      let publishUrl = undefined
      if(platform === 'fxg_gxzy') {
        publishType = 'FXG_GXPT_PUBLISH_ITEM'
        params = {
          baseItemIds,
          shopIds,
          publishEntrance,
          publishType: 'FXG_GXPT_PUBLISH_ITEM',
          isDistribution:+this.isDistributor,
          channel,
        }
        publishUrl = '/item/platform/publish'
      } else if (this.publishEntrance == 2) {
        // 供销商展架页
        params.supplierItemInfos = list.map(row => {
          return {
            supplierItemId: row.baseItemId,
            supplierCompanyId: row.companyId,
          }
        });
      }
      // 裂变重新铺货参数
      if(taskCenterId && _publishType == 5){
        let batchPublishParams = list.map(item => {
          return {
              itemId:item.baseItemId,
              shopId:item.shopId,
              taskCenterId:item.taskCenterId
          }
        });
        params.subTaskType = 'GOODS_FISSION_PUBLISH'
        params.batchPublishParams = batchPublishParams
      }
      const res = await publishGoods(params, publishUrl)
      if (res) {
        //铺货进度查询
        this.setCurrentPage(`${this.routerPrefix}log`);
        await this.publishSpeed({ publishType, resultVisible: true, batchTaskId: platform === 'fxg_gxzy' ? '' : res });
      } else {
        this.$message.warning('商品铺货失败');
      }
      this.isPublishing = false;
    },
    stopPublishFn(row) {
      this.stopPublish(row)
    },
    async stopPublish(row) {
      const filterList = row ? [row] : this.selectList.filter(item => item.status == -2 || item.status == 3)
      if(!filterList.length) {
        return this.$message.warning('请选择铺货状态为 排队中/图片审核中 状态的商品！');
      }
      const res = await stopPublishTask({
        baseItemIds: filterList.map(item => item.baseItemId),
        operationLogId: filterList[0].operationLogId,
        taskType: 'PUBLISH_ITEM',
      })
      if(res) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: res
        });
        this.fetch_Deatil()
      }
    },
    getPlatformIcon(platform){
      return PLATFORM_ICONS_MAP[platform]
    },
    getPlatformName(platform){
      return PLATFORM_NAME_MAP[platform]
    }
  },
  mounted() {
    if((this.id || this.operationLogId) && ['onShelvesLogNew','onShelvesLog', 'publishStoresLog'].includes(this.getLogActiveName)) {
      this.fetch_Deatil()
    }
    // 异步加载组件
    import('@components/prod/center/dialogs/bulkShelvesResults.vue').then(BulkShelvesResults => {
      this.$options.components.BulkShelvesResults = BulkShelvesResults.default;
      this.isAReady = true;
    }).catch(error => {
      console.error('Failed to load BulkShelvesResults:', error);
    });
  }

}
</script>

<style lang="scss" scoped>
.mar {
  margin:20px 0;
}
.retry-tips{
  display: inline-block;
  margin-left: 20px;
  vertical-align:top;
  line-height: 16px;
  cursor: default;
}
.trigger-tips {
  color: #2965FA;
  font-size: 14px;
  margin: 8px 0px;
  border: none;
}
</style>
